import React, { useEffect, useMemo, useState, useRef } from "react";
import { Card, Button, Stepper, Step, StepButton, Box, Typography } from "@mui/material";
import Header from "../../layout/Header/Header";
import { ThemeProvider } from "@mui/material/styles";
import MentorBasicInfo from "./MentorBasicInfo";
import MentorBackground from "./MentorBackground";
import MentorAcadamicHistory from "./MentorAcadamicHistory";
import MeetingRequirements from "./MeetingRequirements";
import { useNavigate } from "react-router-dom";
import { StepperBg, theme } from "../Styles/StepsStyle";
import { useDispatch, useSelector } from "react-redux";
import Style from "../Styles/CssModulesGlobal.module.scss";
import {
  getUserQuestions, setLoggedInUserId, getQuestionsSavedAnswers, getSchooList,
  setFormErrorsBasicInfo, getUserInfo, getHighSchooList, checkSurveyStatus
} from "../../store/studentSlice";
import { checkPayoutEnabled } from "../../store/AdminSlice";
import en from "../../nls/en.json";
import { setLoader } from '../../store/commonSlice';
import { handleProfileUpload } from "../../utils/fetcher";
import { updateMentor, updateMentorConsignment } from "../../store/mentorSlice";
import Loader from "../../utils/Loader";
import { validateFormBasicInfo } from "../../utils/validation";
import { role, getUserId, isEmpty } from "../../utils/constants";
import PaymentInfo from "./PaymentInfo";
import WarningPopUp from "../common/WarningPopUp";

function getStepContent(step, getBasicInfo, studentQuestions, getLinks, setProfilePic, toggleDialog, myRef, isConsignmentChecked, setconsignment, isSMSChecked, setMentorSMS, isPolicyAndCondChecked, setPolicyConditions) {
  switch (step) {
    case 0:
      return <MentorBasicInfo getBasicInfo={getBasicInfo} isConsignmentChecked={isConsignmentChecked} setconsignment={setconsignment} isSMSChecked={isSMSChecked} setMentorSMS={setMentorSMS} isPolicyAndCondChecked={isPolicyAndCondChecked} setPolicyConditions={setPolicyConditions} />;
    case 1:
      return <MentorAcadamicHistory data={studentQuestions} myRef={myRef}/>;
    case 2:
      return <MentorBackground data={studentQuestions} myRef={myRef}/>;
    case 3:
      return <MeetingRequirements getLinks={getLinks} data={studentQuestions} step={step} myRef={myRef}/>;
    case 4:
      return <MeetingRequirements data={studentQuestions} step={step} setProfilePic={setProfilePic} toggleDialog={toggleDialog} myRef={myRef}/>;
    case 5:
      return <PaymentInfo />
  }
}

const MentorSteps = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { studentQuestions, loggedInUserId, userInfo, isSurveyCompleted } = useSelector(({ studentInfoSlice }) => studentInfoSlice);
  const { isNestedstepCompleted, loader } = useSelector(({ common }) => common);
  //disabling profile during onboarding
  const [isOnboarding, setIsOnboarding] = useState(true); // Initially assume user is in onboarding

  const [isConsignmentChecked, setconsignment] = useState(false);
  const [isSMSChecked, setMentorSMS] = useState(false);
  const [isPolicyAndCondChecked, setPolicyConditions] = useState(false);

  // Each form state
  const [basicInfo, setBasicInfo] = useState({});
  const [meetingLinks, setMeetingLinks] = useState([]);
  const [profilePic, setProfilePic] = useState(userInfo?.profile_page_link);
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const steps = ["Basic Information", "Academic History", "Mentor Background", "Meeting Requirements", "Profile Picture", "Payment Info"];
  const handleStep = (step) => () => setActiveStep(step)
  const totalSteps = () => steps.length;
  const completedSteps = () => Object.keys(completed).length;
  const isLastStep = () => activeStep === totalSteps() - 1;

  useEffect(() => {
    let userId = getUserId();
    dispatch(getUserInfo());
    dispatch(getUserQuestions());
    dispatch(setLoggedInUserId(userId));
    dispatch(getQuestionsSavedAnswers(userId));
    dispatch(getSchooList());
    dispatch(getHighSchooList());
    dispatch(checkSurveyStatus(userId));

    const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('mentorRegistered');
    if (myParam) {
      setActiveStep(5)
    }
  }, []);

  useMemo(() => {
    if (isSurveyCompleted) {
        if (userInfo?.onboarding_status === "ACTIVE") {
            setIsOnboarding(false);
            dispatch(checkPayoutEnabled());
            navigate('/user/mentorDashboard');
        } 
        if (userInfo?.onboarding_status === "PENDING") {
            setActiveStep(5);
        }
    }
}, [isSurveyCompleted, userInfo]);

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const allStepsCompleted = () => completedSteps() === totalSteps();
  const getBasicInfo = (data) => setBasicInfo(data);
  const getLinks = (data) => setMeetingLinks(data);

  const [openDialog, setOpenDialog] = useState(false);
  const toggleDialog = () => setOpenDialog(!openDialog);

  const handleNext = () => {

    if (activeStep === 0) {
      const errors = validateFormBasicInfo(basicInfo, "", "", role.mentor);
      if (Object.keys(errors)?.length !== 0) {
        return dispatch(setFormErrorsBasicInfo(errors));
      }
      const payload = {
        consignment_check: true,
        sms_check: true,
      }
      dispatch(updateMentorConsignment(payload));
    }

    if (activeStep === 4) {
      if (isEmpty(profilePic?.name) && !userInfo?.profile_page_link) {
        toggleDialog();
        return "";
      } else if (!profilePic?.type?.startsWith("image/")) {
        toggleDialog();
        return
      }
    }

    const newActiveStep = isLastStep() && !allStepsCompleted() ? steps.findIndex((step, i) => !(i in completed)) : activeStep + 1;
    setActiveStep(newActiveStep);
    if (newActiveStep === 0) {
      setIsOnboarding(false)
      navigate("/user/mentorDashboard");
    }

    // Profile upload picture.
    if (activeStep === 4 && profilePic) {
      dispatch(setLoader(true))
      handleProfileUpload(profilePic, false, false).then(() => {
        dispatch(setLoader(false));
      }).catch(() => {
        dispatch(setLoader(false));
      })
    }
    const { name, lastName, ...rest } = basicInfo;
    const finalPayload = { ...rest, name: `${name} ${lastName}`, calendly_link: meetingLinks?.calendly_link, calendly_token: meetingLinks?.calendly_token }
    dispatch(updateMentor(loggedInUserId, finalPayload));
  };

  const skipStep = () => {
    const newActiveStep = isLastStep() && !allStepsCompleted() ? steps.findIndex((step, i) => !(i in completed)) : activeStep + 1;
    setActiveStep(newActiveStep);
  }

  useMemo(() => {
    if (isNestedstepCompleted) {
      skipStep();
    }
  }, [isNestedstepCompleted]);

  const myRef = useRef(null);
  useEffect(()=>{
    myRef.current.scrollTop = 0;
  },[activeStep]);

  return (
    <ThemeProvider theme={theme}>
      {loader && <Loader loader={true}></Loader>}
      <Header isOnboarding={isOnboarding}/>
      <StepperBg ref={myRef}>
        <Box className={Style.stepperMenu}>
          <Stepper alternativeLabel activeStep={activeStep} sx={{ mb: 5 }}>
            {steps.map((label, index) => (
              <Step key={label} completed={completed[index]}>
                <StepButton color="inherit" onClick={handleStep(index)}>
                  {label}
                </StepButton>
              </Step>
            ))}
          </Stepper>
        </Box>
        <Card className={Style.stepperCard}>

          {getStepContent(activeStep, getBasicInfo, studentQuestions, getLinks, setProfilePic, toggleDialog, myRef, isConsignmentChecked, setconsignment, isSMSChecked, setMentorSMS,  isPolicyAndCondChecked, setPolicyConditions)}

          <Box
            sx={{
              display: "flex",
              justifyContent: "center"
            }}
          >
            
            <Button
              variant="contained"
              className={(activeStep === 1 || activeStep === 2 || activeStep === 5) ? "hiddenCC" : ""}
              onClick={handleNext}
              disabled={ activeStep === 0 && (!isConsignmentChecked || !isSMSChecked || !isPolicyAndCondChecked)}
            >
              {activeStep === steps.length - 1 ? "Finish" : "Next"}
            </Button>
            {activeStep !== steps.length &&
              (completed[activeStep] ? (
                <Typography variant="caption" sx={{ display: "inline-block" }}>
                  Step {activeStep + 1} already completed
                </Typography>
              ) : (
                <Button onClick={handleComplete} sx={{ display: 'none' }}>
                  {completedSteps() === totalSteps() - 1 ? "Finish" : "Complete Step"}
                </Button>
              ))}
          </Box>
        </Card>
      </StepperBg>
      <WarningPopUp
        openDialog={openDialog}
        handleCloseDialog={toggleDialog}
        dialogMessage={activeStep === 4 ? en.PROFILE_ERROR_MSG : en.WARNING_POPUP_MSG}
      />
    </ThemeProvider>
  );
};

export default MentorSteps;
